<template>
  <div class="b2c-rank-desc container">
    <component
      :is="brandUpgrade ? 'newRankItem' : 'oldRankItem'"
      v-if="isMicro && inZZ"
      ref="rankItemRef"
      :isMicro="isMicro"
      :inZZ="inZZ"
      :inZlj="inZlj"
      :qualityRatingModule="qualityRatingModule"
      :channelId="channelId"
      :cateId="cateId"
      :infoId="infoId"
      :pageId="pageId"
      :sectionId="sectionId"
      @microClosePopup="microClosePopup"
      v-on="$listeners"
    />
    <z-popup
      v-else
      v-model="show"
      position="bottom"
      class="popup"
      :class="getContainer && 'isMicro'"
      :get-container="getContainer"
    >
      <component
        :is="brandUpgrade ? 'newRankItem' : 'oldRankItem'"
        ref="rankItemRef"
        :isMicro="isMicro"
        :inZZ="inZZ"
        :inZlj="inZlj"
        :eventName="eventName"
        :qualityRatingModule="qualityRatingModule"
        :channelId="channelId"
        :cateId="cateId"
        :infoId="infoId"
        :pageId="pageId"
        :sectionId="sectionId"
        :showFeedback="showFeedback"
        :feedbackData="feedbackData"
        :notFeedBack="notFeedBack"
        v-bind="$attrs"
        @togglePopup="togglePopup"
        @microClosePopup="microClosePopup"
        v-on="$listeners"
      />
    </z-popup>
  </div>
</template>

<script>
  import { lego } from '@zz-common/lego'
  import native from '@zz-common/native-adapter'
  import { Popup } from '@zz-common/zz-ui'
  import oldRankItem from './oldRankItem'
  import newRankItem from './newRankItem'
  import buryingMixins from '../../mixins/zljBurypointMixins'
  import { getCookie } from '../../utils/zljUtils'

  export default {
    name: 'RankDescription',
    components: {
      oldRankItem,
      newRankItem,
      [Popup.name]: Popup,
    },
    mixins: [buryingMixins],
    props: {
      pageId: {
        type: String,
        default: 'T2974',
      },
      sectionId: {
        type: String,
        default: '105',
      },
      getContainer: {
        type: [String, Object],
        default: null,
      },
      isMicro: {
        type: Boolean,
        default: false,
      },
      qualityRatingModule: {
        type: Object,
        default: () => ({}),
      },
      eventName: {
        type: String,
        default: 'click_app',
      },
      channelId: {
        type: Number,
        default: 0,
      },
      cateId: {
        type: Number,
        default: 0,
      },
      infoId: {
        type: String,
        default: '',
      },
      brandUpgrade: {
        type: Boolean,
        default: false,
      },
      showFeedback: {
        type: Boolean,
        default: () => false,
      },
      feedbackData: {
        type: Object,
        default: () => {
          return {}
        },
      },
      notFeedBack: {
        type: Boolean,
        default: () => false,
      },
    },
    data() {
      return {
        show: false,
        inZlj: native.in('zlj') || getCookie('t') == 141,
        inZZ: native.in('zz') || getCookie('t') == 103,
      }
    },
    methods: {
      togglePopup() {
        this.show = !this.show
      },
      showPopup() {
        this.show = true
      },
      microClosePopup() {
        this.$emit('microClosePopup')
      },
    },
    watch: {
      show(show) {
        const { finenessDialogContents, finenessLevelValueId } = this.qualityRatingModule
        const activeTab =
          (finenessDialogContents || []).find(({ valueId }) => valueId === finenessLevelValueId) ||
          {}
        if (show) {
          this.popupOpenTime = Date.now()
          lego.send({
            pagetype: 'zpmclick', // 埋点类型
            actiontype: this.pageId, // pageId
            backup: {
              channelId: this.channelId, // 渠道id
              sortName: '等级弹窗-打开',
              sortId: 0,
              firsttab: activeTab.finenessName, // tab名称
              infoId: this.infoId, // 商品id
              pl_id: this.cateId, // 品类id
              sectionId: this.sectionId,
            },
          })
        } else {
          this.$refs.rankItemRef.pauseVideo()
          const duration = Date.now() - this.popupOpenTime
          this.buryPointSend(this.eventName, {
            operation_module: '关闭等级说明',
            stay_duration: duration / 1000,
          })
          lego.send({
            pagetype: 'zpmclick', // 埋点类型
            actiontype: this.pageId, // pageId
            backup: {
              channelId: this.channelId, // 渠道id
              sortName: '等级弹窗-关闭',
              sortId: 1,
              firsttab: activeTab.finenessName, // tab名称
              infoId: this.infoId, // 商品id
              pl_id: this.cateId, // 品类id
              sectionId: this.sectionId,
              eventduration: duration / 1000,
            },
          })
        }
      },
    },
  }
</script>

<style lang="scss">
  .container.b2c-rank-desc {
    position: relative;
    .popup {
      width: 750px;
      height: 80vh;
      overflow-y: auto;
      background: #ffffff;
      border-radius: 32px 32px 0px 0px;
      box-sizing: border-box;
    }
  }
  .isMicro.popup {
    background: #ffffff;
    overflow-y: auto;
    height: 80vh;
  }
</style>
